import {
    CompositionInformation,
    getComponentsInCompositions,
    ComponentInformation,
} from 'json-react-layouts'
import { isInlineAdContent } from 'component-library/templates/Publication/lib/get-inline-positioned-ads'
import { InlineAdContent } from 'component-library/templates/Publication/SharedPublication.routing'
import {
    isAdUnitComponent,
    isPublicationComponent,
    isComponentWithInlineContentAds,
    isArticleComponent,
    isGalleryComponent,
    isFeatureComponent,
    isAmpAdUnitComponent,
} from '../__App/component-rendering/helpers'
import { TogglesState } from 'common/feature-togglings/reducer'
import { isComponentEnabled } from 'common/component-middlewares'
import { Features } from 'common/features'
import { AdDefinition } from 'common/advertising/add-ads'

export function getRouteInfoAdUnits(
    toggles: TogglesState,
    compositions: Array<CompositionInformation<any, any, any, any>>
) {
    const adUnits: AdDefinition[] = []
    function addAdUnits(component: ComponentInformation<any, any>, ...ads: AdDefinition[]) {
        if (isComponentEnabled(toggles, (component as { feature?: Features }).feature)) {
            adUnits.push(...ads)
        }
    }

    // TODO We are filtering top level compositions, but this will *not* filter nested compositions
    // doing this will require modifying the react-json-layouts library
    for (const contentArea of getComponentsInCompositions(
        compositions.filter(composition =>
            isComponentEnabled(toggles, (composition as { feature?: Features }).feature)
        ),
        ''
    )) {
        const component: ComponentInformation<any, any> = contentArea

        if (isAdUnitComponent(component) || isAmpAdUnitComponent(component)) {
            const adUnitProps = component.props
            addAdUnits(component, adUnitProps.slot)
        }

        // The publication component uses a more comprehensive "inlinePublicationContent" strategy
        if (
            isPublicationComponent(component) ||
            isArticleComponent(component) ||
            isGalleryComponent(component) ||
            isFeatureComponent(component)
        ) {
            const publicationPropsMeta = component.props.meta

            if (publicationPropsMeta.kind === 'gallery') {
                addAdUnits(component, ...publicationPropsMeta.galleryAds.map(ad => ad.slot))
                return
            }

            const inlineContentAds = publicationPropsMeta.inlinePublicationContent
                ? publicationPropsMeta.inlinePublicationContent
                      .filter(isInlineAdContent)
                      .reduce((acc: AdDefinition[], contentBlock: InlineAdContent) => {
                          acc.push(...contentBlock.content.map(ad => ad.slot))
                          return acc
                      }, [])
                : undefined

            if (inlineContentAds) {
                addAdUnits(component, ...inlineContentAds)
            }
        }
        if (isComponentWithInlineContentAds(component)) {
            const inlineContentAds = component.props.inlineContentAds.map(ad => ad.slot)
            addAdUnits(component, ...inlineContentAds)
        }
    }

    return adUnits
}
